import {$, w} from './constants';
import { trackEvent } from "./gtm.js"; 

// Simulador Notas Estructuradas
$('.sim_tipo_JS').on('change', simulador)
$('.sim_tipo_JS').each(function () { simulador.call(this) })

function simulador() {
	const mod = $(this).find('option:selected').data('mod')

	// Sync Activo subyacente
	const activo = $('.sim_activo_JS')
	activo.find('option').each(function () {
		if ($(this).data('mod') === mod) {
			$(this).prop('selected', true)
			return false
		}
	})

	// Sync Cómo funciona/Ejemplo
	const cols = $('.sim_item_JS')
	cols.hide()
	cols.filter(`[data-mod="${mod}"]`).show()

	$('.sim_esc_JS').removeClass('active')
	$('.sim_esc_JS[data-esc="0"]').addClass('active')
}

$('.sim_esc_JS').click(function () {
	const esc = $(this).data('esc')
	$('.sim_esc_JS').removeClass('active')
	$('.sim_esc_JS[data-esc="'+esc+'"]').addClass('active')
})
